export const ERC20MintableBurnable = {
  _format: "hh-sol-artifact-1",
  contractName: "ERC20MintableBurnable",
  sourceName: "contracts/templates/ERC20MintableBurnable.sol",
  abi: [
    {
      inputs: [
        {
          internalType: "string",
          name: "name",
          type: "string",
        },
        {
          internalType: "string",
          name: "symbol",
          type: "string",
        },
        {
          internalType: "address",
          name: "initialOwner",
          type: "address",
        },
      ],
      stateMutability: "payable",
      type: "constructor",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "spender",
          type: "address",
        },
        {
          internalType: "uint256",
          name: "allowance",
          type: "uint256",
        },
        {
          internalType: "uint256",
          name: "needed",
          type: "uint256",
        },
      ],
      name: "ERC20InsufficientAllowance",
      type: "error",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "sender",
          type: "address",
        },
        {
          internalType: "uint256",
          name: "balance",
          type: "uint256",
        },
        {
          internalType: "uint256",
          name: "needed",
          type: "uint256",
        },
      ],
      name: "ERC20InsufficientBalance",
      type: "error",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "approver",
          type: "address",
        },
      ],
      name: "ERC20InvalidApprover",
      type: "error",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "receiver",
          type: "address",
        },
      ],
      name: "ERC20InvalidReceiver",
      type: "error",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "sender",
          type: "address",
        },
      ],
      name: "ERC20InvalidSender",
      type: "error",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "spender",
          type: "address",
        },
      ],
      name: "ERC20InvalidSpender",
      type: "error",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "owner",
          type: "address",
        },
      ],
      name: "OwnableInvalidOwner",
      type: "error",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "account",
          type: "address",
        },
      ],
      name: "OwnableUnauthorizedAccount",
      type: "error",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "owner",
          type: "address",
        },
        {
          indexed: true,
          internalType: "address",
          name: "spender",
          type: "address",
        },
        {
          indexed: false,
          internalType: "uint256",
          name: "value",
          type: "uint256",
        },
      ],
      name: "Approval",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "previousOwner",
          type: "address",
        },
        {
          indexed: true,
          internalType: "address",
          name: "newOwner",
          type: "address",
        },
      ],
      name: "OwnershipTransferred",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "from",
          type: "address",
        },
        {
          indexed: true,
          internalType: "address",
          name: "to",
          type: "address",
        },
        {
          indexed: false,
          internalType: "uint256",
          name: "value",
          type: "uint256",
        },
      ],
      name: "Transfer",
      type: "event",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "owner",
          type: "address",
        },
        {
          internalType: "address",
          name: "spender",
          type: "address",
        },
      ],
      name: "allowance",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "spender",
          type: "address",
        },
        {
          internalType: "uint256",
          name: "value",
          type: "uint256",
        },
      ],
      name: "approve",
      outputs: [
        {
          internalType: "bool",
          name: "",
          type: "bool",
        },
      ],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "account",
          type: "address",
        },
      ],
      name: "balanceOf",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "value",
          type: "uint256",
        },
      ],
      name: "burn",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "account",
          type: "address",
        },
        {
          internalType: "uint256",
          name: "value",
          type: "uint256",
        },
      ],
      name: "burnFrom",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [],
      name: "decimals",
      outputs: [
        {
          internalType: "uint8",
          name: "",
          type: "uint8",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "to",
          type: "address",
        },
        {
          internalType: "uint256",
          name: "amount",
          type: "uint256",
        },
      ],
      name: "mint",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [],
      name: "moontools",
      outputs: [
        {
          internalType: "address",
          name: "",
          type: "address",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "name",
      outputs: [
        {
          internalType: "string",
          name: "",
          type: "string",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "owner",
      outputs: [
        {
          internalType: "address",
          name: "",
          type: "address",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "price",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "renounceOwnership",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [],
      name: "symbol",
      outputs: [
        {
          internalType: "string",
          name: "",
          type: "string",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "totalSupply",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "to",
          type: "address",
        },
        {
          internalType: "uint256",
          name: "value",
          type: "uint256",
        },
      ],
      name: "transfer",
      outputs: [
        {
          internalType: "bool",
          name: "",
          type: "bool",
        },
      ],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "from",
          type: "address",
        },
        {
          internalType: "address",
          name: "to",
          type: "address",
        },
        {
          internalType: "uint256",
          name: "value",
          type: "uint256",
        },
      ],
      name: "transferFrom",
      outputs: [
        {
          internalType: "bool",
          name: "",
          type: "bool",
        },
      ],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "newOwner",
          type: "address",
        },
      ],
      name: "transferOwnership",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
  ],
  bytecode:
    "0x60806040819052600680546001600160a01b03191673e12f8194b70120e832f4526cdae36b39ccbfa21917905566038d7ea4c6800060075562000de53881900390819083398101604081905262000056916200025c565b80838360036200006783826200037a565b5060046200007682826200037a565b5050506001600160a01b038116620000a957604051631e4fbdf760e01b8152600060048201526024015b60405180910390fd5b620000b48162000142565b50600754341015620000fb5760405162461bcd60e51b815260206004820152600f60248201526e706c656173652073656e642066656560881b6044820152606401620000a0565b6006546007546040516001600160a01b039092169181156108fc0291906000818181858888f1935050505015801562000138573d6000803e3d6000fd5b5050505062000446565b600580546001600160a01b038381166001600160a01b0319831681179093556040519116919082907f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e090600090a35050565b634e487b7160e01b600052604160045260246000fd5b600082601f830112620001bc57600080fd5b81516001600160401b0380821115620001d957620001d962000194565b604051601f8301601f19908116603f0116810190828211818310171562000204576200020462000194565b81604052838152602092508660208588010111156200022257600080fd5b600091505b8382101562000246578582018301518183018401529082019062000227565b6000602085830101528094505050505092915050565b6000806000606084860312156200027257600080fd5b83516001600160401b03808211156200028a57600080fd5b6200029887838801620001aa565b94506020860151915080821115620002af57600080fd5b50620002be86828701620001aa565b604086015190935090506001600160a01b0381168114620002de57600080fd5b809150509250925092565b600181811c90821680620002fe57607f821691505b6020821081036200031f57634e487b7160e01b600052602260045260246000fd5b50919050565b601f82111562000375576000816000526020600020601f850160051c81016020861015620003505750805b601f850160051c820191505b8181101562000371578281556001016200035c565b5050505b505050565b81516001600160401b0381111562000396576200039662000194565b620003ae81620003a78454620002e9565b8462000325565b602080601f831160018114620003e65760008415620003cd5750858301515b600019600386901b1c1916600185901b17855562000371565b600085815260208120601f198616915b828110156200041757888601518255948401946001909101908401620003f6565b5085821015620004365787850151600019600388901b60f8161c191681555b5050505050600190811b01905550565b61098f80620004566000396000f3fe608060405234801561001057600080fd5b50600436106100db5760003560e01c806306fdde03146100e0578063095ea7b3146100fe57806318160ddd1461012157806323b872dd14610133578063313ce5671461014657806340c10f191461015557806342966c681461016a57806370a082311461017d578063715018a6146101a657806379cc6790146101ae5780638da5cb5b146101c157806395d89b41146101d6578063a035b1fe146101de578063a9059cbb146101e7578063cf4a5203146101fa578063dd62ed3e1461020d578063f2fde38b14610220575b600080fd5b6100e8610233565b6040516100f5919061078a565b60405180910390f35b61011161010c3660046107f5565b6102c5565b60405190151581526020016100f5565b6002545b6040519081526020016100f5565b61011161014136600461081f565b6102df565b604051601281526020016100f5565b6101686101633660046107f5565b610303565b005b61016861017836600461085b565b610319565b61012561018b366004610874565b6001600160a01b031660009081526020819052604090205490565b610168610326565b6101686101bc3660046107f5565b61033a565b6101c961034f565b6040516100f59190610896565b6100e861035e565b61012560075481565b6101116101f53660046107f5565b61036d565b6006546101c9906001600160a01b031681565b61012561021b3660046108aa565b61037b565b61016861022e366004610874565b6103a6565b606060038054610242906108dd565b80601f016020809104026020016040519081016040528092919081815260200182805461026e906108dd565b80156102bb5780601f10610290576101008083540402835291602001916102bb565b820191906000526020600020905b81548152906001019060200180831161029e57829003601f168201915b5050505050905090565b6000336102d38185856103ea565b60019150505b92915050565b6000336102ed8582856103fc565b6102f885858561044f565b506001949350505050565b61030b6104ae565b61031582826104e0565b5050565b6103233382610516565b50565b61032e6104ae565b610338600061054c565b565b6103458233836103fc565b6103158282610516565b6005546001600160a01b031690565b606060048054610242906108dd565b6000336102d381858561044f565b6001600160a01b03918216600090815260016020908152604080832093909416825291909152205490565b6103ae6104ae565b6001600160a01b0381166103e1576000604051631e4fbdf760e01b81526004016103d89190610896565b60405180910390fd5b6103238161054c565b6103f7838383600161059e565b505050565b6000610408848461037b565b90506000198114610449578181101561043a57828183604051637dc7a0d960e11b81526004016103d893929190610917565b6104498484848403600061059e565b50505050565b6001600160a01b038316610479576000604051634b637e8f60e11b81526004016103d89190610896565b6001600160a01b0382166104a357600060405163ec442f0560e01b81526004016103d89190610896565b6103f7838383610673565b336104b761034f565b6001600160a01b031614610338573360405163118cdaa760e01b81526004016103d89190610896565b6001600160a01b03821661050a57600060405163ec442f0560e01b81526004016103d89190610896565b61031560008383610673565b6001600160a01b038216610540576000604051634b637e8f60e11b81526004016103d89190610896565b61031582600083610673565b600580546001600160a01b038381166001600160a01b0319831681179093556040519116919082907f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e090600090a35050565b6001600160a01b0384166105c857600060405163e602df0560e01b81526004016103d89190610896565b6001600160a01b0383166105f2576000604051634a1406b160e11b81526004016103d89190610896565b6001600160a01b038085166000908152600160209081526040808320938716835292905220829055801561044957826001600160a01b0316846001600160a01b03167f8c5be1e5ebec7d5bd14f71427d1e84f3dd0314c0f7b2291e5b200ac8c7c3b9258460405161066591815260200190565b60405180910390a350505050565b6001600160a01b03831661069e5780600260008282546106939190610938565b909155506106fd9050565b6001600160a01b038316600090815260208190526040902054818110156106de5783818360405163391434e360e21b81526004016103d893929190610917565b6001600160a01b03841660009081526020819052604090209082900390555b6001600160a01b03821661071957600280548290039055610738565b6001600160a01b03821660009081526020819052604090208054820190555b816001600160a01b0316836001600160a01b03167fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef8360405161077d91815260200190565b60405180910390a3505050565b60006020808352835180602085015260005b818110156107b85785810183015185820160400152820161079c565b506000604082860101526040601f19601f8301168501019250505092915050565b80356001600160a01b03811681146107f057600080fd5b919050565b6000806040838503121561080857600080fd5b610811836107d9565b946020939093013593505050565b60008060006060848603121561083457600080fd5b61083d846107d9565b925061084b602085016107d9565b9150604084013590509250925092565b60006020828403121561086d57600080fd5b5035919050565b60006020828403121561088657600080fd5b61088f826107d9565b9392505050565b6001600160a01b0391909116815260200190565b600080604083850312156108bd57600080fd5b6108c6836107d9565b91506108d4602084016107d9565b90509250929050565b600181811c908216806108f157607f821691505b60208210810361091157634e487b7160e01b600052602260045260246000fd5b50919050565b6001600160a01b039390931683526020830191909152604082015260600190565b808201808211156102d957634e487b7160e01b600052601160045260246000fdfea26469706673582212203753e24a60548fca96413980e91631ddac25cae75e543c2c2ce0cf67830b45ea64736f6c63430008180033",
  deployedBytecode:
    "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",
  linkReferences: {},
  deployedLinkReferences: {},
};
